import RFQDashboard from './RFQDashboard_Sendify';
import './App.css';

export default function App() {
  return <div className="App"><RFQDashboard /></div>;
}
